import { render, staticRenderFns } from "./CenterViewEdit_Ap.vue?vue&type=template&id=6f2804a6&scoped=true"
import script from "./CenterViewEdit_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEdit_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEdit_Ap.vue?vue&type=style&index=0&id=6f2804a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2804a6",
  null
  
)

export default component.exports